'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoPullRequest = function IoPullRequest(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 5c2.7 0 5 2.3 5 5 0 1.9-1 3.4-2.5 4.3v13.9c1.5 0.9 2.5 2.4 2.5 4.3 0 2.7-2.3 5-5 5s-5-2.3-5-5c0-1.9 1-3.4 2.5-4.3v-13.9c-1.5-0.9-2.5-2.4-2.5-4.3 0-2.7 2.3-5 5-5z m0 30c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m0-22.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m22.4 15.6c1.6 0.9 2.6 2.5 2.6 4.4 0 2.7-2.3 5-5 5s-5-2.3-5-5c0-1.8 0.9-3.4 2.4-4.3v-12.2c0-1.2-0.3-2-0.8-2.6-0.8-0.7-2.1-0.9-4.1-0.9v5l-7.5-7.5 7.5-7.5v5c3.3-0.1 5.8 0.6 7.5 2.3 1.6 1.4 2.4 3.6 2.4 6.2v12.1z m-2.4 6.9c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z' })
        )
    );
};

exports.default = IoPullRequest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/pull-request.js
// module id = 2394
// module chunks = 0